<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="6" sm="12" class="mt-2">
          <div style="padding: 10px;border: 2px solid #c4c6be;border-radius: 15px;">
            <b-form-group
              id="igCrntPwd"
              horizontal
              label="User Name"
              label-size="sm"
              label-for="inpUserName"
            >
              <b-form-input
                id="inpUserName"
                type="text"
                v-model="form.UserName"
                size="sm"
                placeholder="User ID"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="igNewPwd"
              horizontal
              label="New Password"
              label-size="sm"
              label-for="inpNewPassword"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="inpNewPassword"
                  :type="showNewPassword ? 'text' : 'password'"
                  v-model="form.NewPassword"
                  placeholder="New Password"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="outline-secondary"
                    @click="showNewPassword = !showNewPassword"
                    tabindex="-1"
                  >
                    <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              id="igCnfrmPwd"
              horizontal
              label="Confirm New Password"
              label-size="sm"
              label-for="inpConfirmNewPassword"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="inpConfirmNewPassword"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  v-model="form.ConfirmNewPassword"
                  placeholder="Confirm New Password"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="outline-secondary"
                    @click="showConfirmPassword = !showConfirmPassword"
                    tabindex="-1"
                  >
                    <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 justify-content-md-center">
        <b-col md="4" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align:right">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import apis from "@/apis";
import * as _ from "lodash";
import Spinner from "vue-simple-spinner";
import axios from "axios";

import lambda from "@/apis/lambda";

const _SheetJSFT = ["jpeg", "jpg", "png", "pdf"];
export default {
  components: { Spinner },
  data() {
    return {
      form: {
        ConfirmNewPassword: "",
        NewPassword: "",
        UserName: "",
        LoginID: ""
      },
      isValue: false,
      isSaved: false,
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      showNewPassword: false,
      showConfirmPassword: false
    };
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.isSaved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.showDismissibleAlert = false;
      this.isLoading = true;
       if (
        this.form.NewPassword ===""
      ) {
        this.alertText = "Please enter new Password";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
       if (
        this.form.ConfirmNewPassword===""
      ) {
        this.alertText = "Please enter Confirm new Password";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
       if (
        this.form.UserName===""
      ) {
        this.alertText = "Please enter User Name";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (
        this.form.NewPassword !==
        this.form.ConfirmNewPassword
      ) {
        this.alertText = "New Password and Confirm Password should be same";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.changePassword(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Password changed Please try login with new password";
            this.isSaved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
  },
  computed: {
    getUserData() {
      let x = this.$store.getters.getUserData;
      let OrganizationName = "";
      let ProductfromOrganization = "";
      let OrganizationAddress = "";
      let AmountFromBank = 0;

      return {
        LockProfile: x.LockProfile
      };
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      // this.getUserBankDetails();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/ChangePassword.vue